/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import safeGet from 'lodash.get';
import getDefaultState from './util';
import { capi } from '../../client/setup';

export default {
  namespaced: true,

  state: {
    ...getDefaultState(),
  },

  getters: {
    locale: (state) => state.locale,
    suppliedFormData: (state) => state.suppliedFormData,
    countries: (state) => state.countries,
    exchangeIdentifier: (state) => state.exchangeIdentifier,
    deviceVerificationResponse: (state) => state.deviceVerificationResponse,
    getSelectedCountryCode: (state, getters) => (
      getters.suppliedFormData?.selectedCountryRegion?.countryCode
    ),
    getDeviceProductPageUrl: (state, getters, rootState, rootGetters) => {
      const identifier = getters.suppliedFormData?.serialNumber;
      const { supportPublicBaseUrl } = window.AppData;
      return `${supportPublicBaseUrl}/${rootGetters.locale}/?identifier=${identifier}&tab=topics&contactOverride=true`;
    },
    getCountriesTransformed: (state) => (state.countries || []).reduce((acc, curr) => {
      acc[curr.locale] = curr.displayName;
      return acc;
    }, {}),
    findSelectedCountry: (state) => (locale) => (state.countries || []).find(
      (c) => c.locale === locale,
    ),
    isDeviceInOrUnknownWarranty: (state, getters) => {
      const warrantyStatus = getters.deviceVerificationResponse?.rmaWarrantyStatus?.warrantyState;
      const warrantyCode = getters.deviceVerificationResponse?.rmaWarrantyStatus?.warrantyCode;
      return (
        warrantyStatus === 'IN'
        || warrantyCode === 'OUT_OF_WARRANTY_UNKNOWN'
      );
    },

    provideErrorToProductPage: (state, getters) => (
      getters.isDeviceInOrUnknownWarranty
        || (
          getters.deviceVerificationResponse?.serialNumberInDb
          && (
            !getters.deviceVerificationResponse?.rmaOutboundProductDetail
            || !getters.deviceVerificationResponse?.paidRMADetails?.repairPrice
            || !getters.deviceVerificationResponse?.paidRMADetails?.currency
          )
        )
    ),
    insertCountryNames: (state, getters, rootState, rootGetters) => (validLocales) => {
      const { orderInformationForm: { countryNameMappings } } = rootGetters.translations;

      return validLocales.reduce((acc, curr) => {
        const displayName = countryNameMappings.find((c) => c?.fields?.key === curr)?.fields?.value;
        const countryCode = curr.split('_')[1];

        if (displayName) {
          acc.push({
            displayName,
            countryCode,
            locale: curr,
          });
        }

        return acc;
      }, []).sort((countryOne, countryTwo) => {
        const currLocale = rootGetters.locale.replace('-', '_');
        if (countryOne.locale === currLocale) return -1;
        if (countryTwo.locale === currLocale) return 1;

        return countryOne.displayName.localeCompare(countryTwo.displayName);
      });
    },
  },

  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    setSuppliedFormData(state, data) {
      state.suppliedFormData = data;
    },
    setCountries(state, data) {
      state.countries = data;
    },
    setExchangeIdentifier(state, data) {
      state.exchangeIdentifier = data;
    },
    setDeviceVerificationResponse(state, data) {
      state.deviceVerificationResponse = data;
    },
  },

  actions: {
    reset({ commit }) {
      commit('reset');
    },
    updateSuppliedValidationData({ commit, getters }, data = {}) {
      commit('setSuppliedFormData', { ...data, selectedCountryRegion: getters.findSelectedCountry(data.selectedCountryRegion) });
    },
    updateExchangeIdentifer({ commit }, { exchangeType, exchangeId }) {
      if (
        exchangeType
        && exchangeId
      ) commit('setExchangeIdentifier', `${exchangeType}-${exchangeId}`);
    },
    async fetchCountries({ commit, getters }, payload = {}) {
      try {
        let qs = '';

        if (getters.exchangeIdentifier) {
          qs = new URLSearchParams({
            caseId: getters.exchangeIdentifier,
          }).toString();
        }

        payload.params = {
          locale: getters.locale,
        };

        const path = `countries/?${qs}`;
        const { data: { validLocales } } = await capi.get(path, payload);
        commit('setCountries', getters.insertCountryNames(validLocales));
      } catch (e) {
        commit('setCountries', null);
      }
    },
    async deviceVerification({ commit }, payload = {}) {
      try {
        const { data: { onlineRMAValidationDetails } } = await capi.post('deviceOrderVerification', payload);
        commit('setDeviceVerificationResponse', onlineRMAValidationDetails);
      } catch (e) {
        commit('setDeviceVerificationResponse', null);
      }
    },
  },
};
